import { api } from '@/modules/apiv2';

export default {
  state: {
    device: null,
    devices: [],
  },

  getters: {
    device(state) {
      return state.device;
    },

    devices(state) {
      return state.devices;
    },
  },

  mutations: {
    setDevice(state, device) {
      state.device = device;
    },

    setDevices(state, devices) {
      state.devices = devices;
    },
  },

  actions: {
    getDevice({ commit, getters }, deviceId) {
      const endpoint = getters.devicesEndpoint;

      return api
        .get(`${endpoint}/${deviceId}`)
        .then((data) => {
          commit('setDevice', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    getDevices({ commit, getters, dispatch }) {
      if (getters.currentUserIsOwner) {
        const endpoint = getters.devicesEndpoint;
        return api
          .get(endpoint)
          .then((data) => {
            commit('setDevices', data);
            return data;
          })
          .catch((error) => {
            throw error;
          });
      } else if (getters.currentUserIsConsumer) {
        return dispatch('getConsumerDevices');
      }
    },

    getConsumerDevice({ commit, getters }, deviceId) {
      const connection = getters.connection;
      const endpoint = getters.connectionsEndpoint;

      return api
        .get(`${endpoint}/${connection.id}/devices/${deviceId}`)
        .then((data) => {
          commit('setDevice', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    getConnectionDevices({ getters }, connectionId) {
      const endpoint = getters.connectionsEndpoint;

      return api
        .get(`${endpoint}/${connectionId}/devices`)
        .then((data) => {
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    async getConsumerDevices({ commit, dispatch }, connectionId) {
      let devices = await dispatch('getConnectionDevices', connectionId);
      commit('setDevices', devices);
      return devices;
    },

    // Device not actually created until provisioned on RMS machine,
    // so don't set device here.

    createDevice({ getters }, data) {
      const endpoint = getters.devicesEndpoint;

      return api
        .post(endpoint, data)
        .then((data) => {
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    updateDevice({ commit, getters }, data) {
      const endpoint = getters.devicesEndpoint;

      return api
        .put(`${endpoint}/${data.id}`, data)
        .then((data) => {
          commit('setDevice', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    deleteDevice({ commit, getters }, id) {
      const endpoint = getters.devicesEndpoint;

      return api
        .delete(`${endpoint}/${id}`)
        .then((response) => {
          commit('setDevice', null);
          return response;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
